// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fb-a";
export var fulfillmentFormRail = "_fb-9";
export var headerTitleRow = "_fb-c";
export var orderDetailsWrapper = "_fb-7";
export var orderLinkTrigger = "_fb-2";
export var paymentInformationGrid = "_fb-h";
export var paymentSummaryColumn = "_fb-i";
export var shipmentContainer = "_fb-b";
export var shipmentDetailsMainPane = "_fb-8";
export var shipmentNavigationCard = "_fb-5";
export var shipmentNavigationRail = "_fb-3";
export var shipmentNavigationRailHeader = "_fb-4";
export var shipmentSummaryFact = "_fb-e";
export var shipmentSummaryGrid = "_fb-d";
export var shipmentSummaryMetadataRow = "_fb-f";
export var shipmentSummaryTags = "_fb-g";
export var shipmentWorkspace = "_fb-0";
export var shipmentWorkspaceContent = "_fb-6";
export var shipmentWorkspaceHeader = "_fb-1";